// ENTITY fr.gestionpial.pial.dto.EtapeTraceDTO generated by ic2 no-version-available at Thu Oct 01 15:16:31 UTC 2026

import { mapping, fields } from '@ic2/ic2-lib';

export class EtapeTraceDTO {

  static readonly __ic2_fqn: string = 'fr.gestionpial.pial.dto.EtapeTraceDTO';

  phase: string | null = '';
  message: string | null = '';

  constructor(init?:Partial<EtapeTraceDTO>) {
    Object.assign(this, init);
  }

  toString() {
    return JSON.stringify(this);
  }

}

mapping['fr.gestionpial.pial.dto.EtapeTraceDTO'] = EtapeTraceDTO;

fields['fr.gestionpial.pial.dto.EtapeTraceDTO']  = {
    phase: 'java.lang.String',
    message: 'java.lang.String'
};
